import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../shared/authentication/auth-guard';

import { GerenciarEditalCredenciamentoComponent } from './gerenciar-edital-credenciamento/gerenciar-edital-credenciamento.component';
import { EditalCredenciamentoFormComponent } from './edital-credenciamento-form/edital-credenciamento-form.component';

const EditalCredenciamentoRoutes: Routes = [
    { path: 'gerenciar-edital-credenciamento', component: GerenciarEditalCredenciamentoComponent, canActivate: [ AuthGuard ] },
    {
        path: 'edital-credenciamento-form/:idEditalCredenciamento',
        component: EditalCredenciamentoFormComponent,
        canActivate: [ AuthGuard ]
    },
    { path: 'edital-credenciamento-form', component: EditalCredenciamentoFormComponent, canActivate: [ AuthGuard ] },
];

export const EditalCredenciamentoRouting = RouterModule.forChild(EditalCredenciamentoRoutes);



// WEBPACK FOOTER //
// ./src/app/components/editalCredenciamento/edital-credenciamento.routing.ts